// removed by extract-text-webpack-plugin
module.exports = {"Form_wrap":"UpdateStatus__Form_wrap__1kD6n","Form_group":"UpdateStatus__Form_group__10Wsb","ContainerBtn":"UpdateStatus__ContainerBtn__2FEw3","Btn":"UpdateStatus__Btn__27TGu","RedBtn":"UpdateStatus__RedBtn__oS2V3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChildController/ViewChild/UpdateStatus/UpdateStatus.css
// module id = 110
// module chunks = 0